export default __webpack_public_path__ + "static/media/logo.3b2de259.png";